import * as moment from 'moment-timezone';

export default class TimeZoneUtils{
    public static ConvertUtcDateToWestEurope(time: Date): moment.Moment{
        const convertedMoment = moment.tz(time, "Etc/UTC");
        return convertedMoment.tz("Europe/Amsterdam");
    }
}